import { FC, useEffect, useMemo } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Header, LogoImage } from '@liveconnect/components'

import useAuth from '../../core/auth/useAuth'
import useUi from '../../core/ui/useUi'
import { ApplicationLogo } from './ApplicationLogo'
import useTenantConfig from '../../core/tenantConfig/useTenantConfig'

import './styles.scss'

const AppHeader: FC = () => {
  const { pathname } = useLocation()

  const { t } = useTranslation()
  const { user } = useAuth()
  const { toggleShowPanel, isPanelVisible } = useUi()
  const { tenantConfig } = useTenantConfig()

  const userTenant = useMemo(() => user?.profile.tenant_id ?? '', [user])

  useEffect(() => {
    isPanelVisible && toggleShowPanel()
  }, [pathname])

  return (
    <Header className="Header">
      <Header.Left>
        <Header.Logo>
          <Link to={`/t/${userTenant}`} className="navbar-brand">
            <ApplicationLogo />
          </Link>
        </Header.Logo>
      </Header.Left>

      <Header.Right>
        {tenantConfig?.tenantLogoUrl && (
          <Header.Logo>
            <LogoImage
              src={tenantConfig.tenantLogoUrl}
              size="sm"
              alt="ifemaLogo"
              className="header__tenant-logo"
            />
          </Header.Logo>
        )}

        <Header.Menu>
          <Header.AvatarButton
            onClick={toggleShowPanel}
            active={isPanelVisible}
            avatar={{
              name: user?.profile.name ?? '',
              surname: user?.profile.family_name ?? '',
              imageUrl: user?.profile.picture ?? '',
              alt: t('header.avatar'),
            }}
          />
        </Header.Menu>
      </Header.Right>
    </Header>
  )
}

export default AppHeader
